import downloadIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/download.svg";
import minusIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/minus.svg";
import userIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/user.svg";
import workplaceIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/workplace.svg";
import XIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/x.svg";
import plusIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/plus.svg";
import atTheRate from "../../../assests/HPE/enterpriseone/ent-a/icons/@.svg";
import phoneIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/phone.svg";
import square from "../../../assests/HPE/enterpriseone/ent-a/icons/square.svg";
import checkbox from "../../../assests/HPE/enterpriseone/ent-a/icons/checkbox.svg";
import circle from "../../../assests/HPE/enterpriseone/ent-a/icons/circle.svg";
import radioChecked from "../../../assests/HPE/enterpriseone/ent-a/icons/radio-checked.svg";
import tree from "../../../assests/HPE/enterpriseone/smb-a/tree.svg";
import database from "../../../assests/HPE/enterpriseone/smb-a/database.svg";
import EnterpriseInput from "../enterprise1/EnterpriseInput";
import { useEffect, useState } from "react";
import CardHeader from "../enterprise1/CardHeader";
// import DocumentPreview from "../components/ui/enterprise1/DocumentPreview";
import document1 from "../../../assests/HPE/enterpriseone/smb-a/webp/zip-document-1.webp";
import document2 from "../../../assests/HPE/enterpriseone/smb-a/webp/zip-document-2.webp";
import ZertoDocumentPreview from "./ZertoDocumentPreview";
import SelectV2 from "../../common/SelectV2";
import { object, string } from "yup";
import axios from "../../../config";
import { Link, useNavigate } from "react-router-dom";
import { useStatsigClient } from "@statsig/react-bindings";
import { useTrackEvent } from "../../../hooks/useTrackEvent";

const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const countryDialCodeMap = {
  Australia: "+61",
  Austria: "+43",
  Canada: "+1",
  Finland: "+358",
  France: "+33",
  Germany: "+49",
  "Hong Kong": "+852",
  India: "+91",
  Indonesia: "+62",
  Ireland: "+353",
  Japan: "+81",
  Malaysia: "+60",
  Netherlands: "+31",
  "New Zealand": "+64",
  Philippines: "+63",
  Singapore: "+65",
  "South Korea": "+82",
  Taiwan: "+886",
  Thailand: "+66",
  "United States": "+1",
  Vietnam: "+84",
};

const phoneRegexByCountry = {
  Australia: /^\d{9,10}$/,
  Austria: /^\d{10,13}$/,
  Canada: /^\d{10}$/,
  Finland: /^\d{9,12}$/,
  France: /^\d{9}$/,
  Germany: /^\d{10,13}$/,
  "Hong Kong": /^\d{8}$/,
  India: /^\d{10}$/,
  Indonesia: /^\d{9,12}$/,
  Ireland: /^\d{9}$/,
  Japan: /^\d{10,11}$/,
  Malaysia: /^\d{9,10}$/,
  Netherlands: /^\d{9}$/,
  "New Zealand": /^\d{8,10}$/,
  Philippines: /^\d{10}$/,
  Singapore: /^\d{8}$/,
  "South Korea": /^\d{9,10}$/,
  Taiwan: /^\d{9}$/,
  Thailand: /^\d{9}$/,
  "United States": /^\d{10}$/,
  Vietnam: /^\d{9,10}$/,
};

const validationSchema = object({
  first_name: string().trim().required("Please enter your full name"),
  email: string()
    .trim()
    .matches(emailRegExp, "Please enter a valid email")
    .required("Please enter an email"),
  company: string().trim().required("Please enter your company name"),
  country: string(),
  phone: string().test(
    "valid-phone-by-country",
    "",
    function validatePhoneByCountry(value) {
      const trimmedValue = value?.trim();
      const { country } = this.parent;

      if (!trimmedValue) return true;

      if (!country) {
        return this.createError({
          path: "country",
          message: "Please select your country",
        });
      }

      const phoneRegex = phoneRegexByCountry[country];
      if (phoneRegex && !phoneRegex.test(trimmedValue)) {
        return this.createError({
          path: "phone",
          message: `Phone number is not valid for ${country}`,
        });
      }

      return true;
    },
  ),
});

const environmentOptions = [
  "On-prem (VMware or physical)",
  "Public cloud workloads (AWS, Azure, GCP)",
  "SaaS applications",
  "A mix or hybrid",
];

const recoveryTestOptions = [
  "Less than 3 months ago",
  "3 to 12 months ago",
  "More than 12 months ago",
  "Never or not sure",
];

const vmsEnvironmentProtectOptions = [
  "Under 50",
  "50 to 200",
  "200 to 500",
  "More than 500",
];

const currentDrSetupOptions = [
  "Traditional scheduled backup only",
  "Backup plus a separate DR tool",
  "Cloud-native snapshots",
  "No formal DR in place",
];

const countryOptions = [
  "Australia",
  "Austria",
  "Canada",
  "Finland",
  "France",
  "Germany",
  "Hong Kong",
  "India",
  "Indonesia",
  "Ireland",
  "Japan",
  "Malaysia",
  "Netherlands",
  "New Zealand",
  "Philippines",
  "Singapore",
  "South Korea",
  "Taiwan",
  "Thailand",
  "United States",
  "Vietnam",
];

const ZertoResourcesForm = ({
  showPreview = true,
  isPopup = false,
  onClose,
  initialFullName = "",
  showQuestionGroupOne = false,
  showQuestionGroupTwo = false,
  variant,
  formLocation,
  statsigDesignId,
}) => {
  const { client } = useStatsigClient();
  const navigate = useNavigate();
  const [name, setName] = useState(initialFullName);
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [environment, setEnvironment] = useState("");
  const [recoveryTest, setRecoveryTest] = useState("");
  const [vmsEnvironmentProtect, setVmsEnvironmentProtect] = useState("");
  const [currentDrSetup, setCurrentDrSetup] = useState("");
  const [country, setCountry] = useState("");
  const [termsCheck, setTermsCheck] = useState(false);
  const [termsCheckError, setTermsCheckError] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOptional, setShowOptional] = useState(false);

  useEffect(() => {
    setName(initialFullName || "");
  }, [initialFullName]);

  function showErrors(validationErrors) {
    const newErrors = {};
    validationErrors.forEach((error) => {
      newErrors[error.path] = error.message;
    });
    setErrors(newErrors);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await validationSchema.validate(
        { first_name: name, email, company, phone, country },
        { abortEarly: false },
      );
      setErrors({});

      if (!termsCheck) {
        setTermsCheckError(true);
        setIsSubmitting(false);
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const utm_source = params.get("utm_source") || "";
      const utm_medium = params.get("utm_medium") || "";
      const utm_campaign = params.get("utm_campaign") || "";
      const formattedPhone = phone
        ? `${countryDialCodeMap[country] || ""} ${phone}`.trim()
        : "";

      const payload = {
        first_name: name,
        last_name: "",
        email,
        company,
        designation: "",
        environment,
        confidence_under_pressure: "",
        recovery_test: recoveryTest,
        vms_environment_protect: vmsEnvironmentProtect,
        current_dr: currentDrSetup,
        country,
        phone: formattedPhone,
        utm_source,
        utm_medium,
        utm_campaign,
      };

      await axios.post("/zerto/submit-form", payload);
      submitTackEvent();
      // firing event to statsig to indicate form submission
      client.logEvent("form_submitted", "zerto");

      navigate("/zerto/thank-you");
    } catch (error) {
      if (error.inner) {
        showErrors(error.inner);
      } else {
        console.log("Error: ", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  const trackEvent = useTrackEvent();

  const submitTackEvent = () => {
    trackEvent(
      {
        event: "lead_smb",
        form_location: formLocation,
        statsig_design_id: statsigDesignId,
      },
      { once: true },
    );
  };

  const docs = [
    { img: document1, title: "Technical Whitepaper", pages: "11 pages · PDF" },
    {
      img: document2,
      title: "Ransomware Resilience Brief",
      pages: "4 pages · PDF",
    },
  ];
  const zertoVariant = variant === "zerto-1";

  return (
    <div className="w-full  py-12 bg-green-03 bg-enterprise-pattern">
      {isPopup && (
        <img
          src={XIcon}
          alt=""
          onClick={onClose}
          className="absolute md:top-4 top-4 right-4 w-5 h-5 text-white cursor-pointer"
        />
      )}
      <div className="flex flex-col gap-10 md:gap-16 md:items-center text-start md:text-center max-w-[1188px] mx-auto px-4 sm:px-6 md:px-10">
        {/* Heading */}
        {zertoVariant === true ? (
          <CardHeader
            title="Take the 2-minute resilience check and get the free technical whitepaper"
            description="Find out exactly where your recovery gaps are. The whitepaper and partner offers download immediately after."
          />
        ) : (
          <CardHeader
            title="Download the free HPE Zerto resource pack"
            description="Technical whitepaper on real-time encryption detection plus the Zerto ransomware resilience brief. Plus exclusive HPE partner offers including 0% financing for up to 3 years."
          />
        )}

        {/* MAIN SECTION */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 w-full">
          {/* LEFT - FORM */}
          <form
            className="flex flex-col gap-6 md:gap-8 w-full md:flex-1"
            onSubmit={handleSubmit}
          >
            {/* Inputs */}
            <div className="flex flex-col gap-5">
              {/* Name */}
              <EnterpriseInput
                theme="zerto"
                icon={userIcon}
                type="text"
                placeholder="Full name*"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setErrors((prev) => ({ ...prev, first_name: "" }));
                }}
                error={errors.first_name}
              />

              {/* Email + Company */}
              <div className="flex flex-col lg:flex-row gap-5 w-full">
                <EnterpriseInput
                  theme="zerto"
                  icon={atTheRate}
                  type="text"
                  placeholder="Work email*"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrors((prev) => ({ ...prev, email: "" }));
                  }}
                  className="w-full"
                  error={errors.email}
                />

                <EnterpriseInput
                  theme="zerto"
                  icon={workplaceIcon}
                  type="text"
                  placeholder="Company name*"
                  value={company}
                  onChange={(e) => {
                    setCompany(e.target.value);
                    setErrors((prev) => ({ ...prev, company: "" }));
                  }}
                  className="w-full"
                  error={errors.company}
                />
              </div>

              {/* Optional Fields */}
              {showOptional && (
                <div className="flex flex-col gap-5 w-full">
                  {showQuestionGroupOne && (
                    <>
                      <div className="flex flex-col gap-4">
                        <p className="text-[14px] leading-[22px] text-grey-02 font-medium text-start">
                          Which environment is hardest for you to recover?
                        </p>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-[12px] leading-[22px] font-normal">
                          {environmentOptions.map((option) => (
                            <label
                              key={option}
                              className="flex items-center gap-3 cursor-pointer"
                              onClick={() => setEnvironment(option)}
                            >
                              <input
                                type="radio"
                                name="environment"
                                value={option}
                                checked={environment === option}
                                onChange={(e) => setEnvironment(e.target.value)}
                                className="hidden"
                              />
                              <img
                                src={
                                  environment === option ? radioChecked : circle
                                }
                                alt=""
                                className="w-[14px] h-[14px] flex-shrink-0"
                              />
                              <span className="text-gray-300 text-[12px] text-start">
                                {option}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="flex flex-col gap-4">
                        <p className="text-[14px] leading-[22px] text-grey-02 font-medium text-start">
                          When was your last full end-to-end recovery test?
                        </p>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-[12px] leading-[22px] font-normal">
                          {recoveryTestOptions.map((option) => (
                            <label
                              key={option}
                              className="flex items-center gap-3 cursor-pointer"
                              onClick={() => setRecoveryTest(option)}
                            >
                              <input
                                type="radio"
                                name="recovery_test"
                                value={option}
                                checked={recoveryTest === option}
                                onChange={(e) =>
                                  setRecoveryTest(e.target.value)
                                }
                                className="hidden"
                              />
                              <img
                                src={
                                  recoveryTest === option
                                    ? radioChecked
                                    : circle
                                }
                                alt=""
                                className="w-[14px] h-[14px] flex-shrink-0"
                              />
                              <span className="text-gray-300 text-[14px] text-start">
                                {option}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="flex flex-col lg:flex-row gap-5 w-full">
                    <div className="w-full">
                      <SelectV2
                        value={country}
                        theme="zerto"
                        onChange={(e) => {
                          setCountry(e.target.value);
                          setErrors((prev) => ({
                            ...prev,
                            country: "",
                            phone: "",
                          }));
                        }}
                        icon={workplaceIcon}
                        error={errors.country}
                      >
                        <option value="" disabled>
                          Select country
                        </option>
                        {countryOptions.map((option) => (
                          <option
                            key={option}
                            value={option}
                            className="text-black"
                          >
                            {option}
                          </option>
                        ))}
                      </SelectV2>
                    </div>

                    <div className="w-full">
                      <EnterpriseInput
                        theme="zerto"
                        icon={phoneIcon}
                        type="text"
                        placeholder="Phone no."
                        value={phone}
                        disabled={!country}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /\D/g,
                            "",
                          );
                          setPhone(numericValue);
                          setErrors((prev) => ({ ...prev, phone: "" }));
                        }}
                        className="w-full"
                        error={errors.phone}
                      />
                    </div>
                  </div>

                  {showQuestionGroupOne && !showQuestionGroupTwo && (
                    <SelectV2
                      theme="zerto"
                      value={vmsEnvironmentProtect}
                      onChange={(e) => setVmsEnvironmentProtect(e.target.value)}
                      icon={tree}
                    >
                      <option value="" disabled>
                        How many VMs or servers does your environment protect?
                      </option>
                      {vmsEnvironmentProtectOptions.map((option) => (
                        <option
                          key={option}
                          value={option}
                          className="text-black"
                        >
                          {option}
                        </option>
                      ))}
                    </SelectV2>
                  )}

                  {showQuestionGroupTwo && !showQuestionGroupOne && (
                    <SelectV2
                      theme="zerto"
                      value={currentDrSetup}
                      onChange={(e) => setCurrentDrSetup(e.target.value)}
                      icon={database}
                    >
                      <option value="" disabled>
                        What is your current DR or backup setup?
                      </option>
                      {currentDrSetupOptions.map((option) => (
                        <option
                          key={option}
                          value={option}
                          className="text-black"
                        >
                          {option}
                        </option>
                      ))}
                    </SelectV2>
                  )}
                </div>
              )}

              {/* Toggle Optional */}
              <div
                onClick={() => setShowOptional((prev) => !prev)}
                className="flex items-center gap-2 text-grey-03 cursor-pointer"
              >
                <img
                  src={showOptional ? minusIcon : plusIcon}
                  className="w-4 h-4"
                  alt=""
                />
                <p>{showOptional ? "Hide optional" : "Show optional"}</p>
              </div>
            </div>

            {/* Checkbox */}
            <div>
              <div className="flex items-start gap-2">
                <input
                  type="checkbox"
                  name="terms-and-condition"
                  id="terms-and-condition"
                  checked={termsCheck}
                  onChange={(e) => {
                    setTermsCheck(e.target.checked);
                    setTermsCheckError(!e.target.checked);
                  }}
                  className="hidden"
                />
                <img
                  src={termsCheck ? checkbox : square}
                  alt=""
                  className="w-4 h-4 mt-0.5 cursor-pointer flex-shrink-0"
                  onClick={() => {
                    setTermsCheck((prev) => !prev);
                    setTermsCheckError(termsCheck);
                  }}
                />
                <p className="text-grey-03 text-[14px] leading-[22px] font-normal text-start font-inter">
                  By submitting this form, I confirm I have read and agree to
                  the Computechoice.com{" "}
                  <Link to="/terms">
                    <span className="font-normal underline">
                      Terms of Use
                    </span>{" "}
                  </Link>
                  and{" "}
                  <Link to="/privacy-policy">
                    <span className="font-normal underline">
                      Privacy Policy
                    </span>
                  </Link>
                  . I authorise Computechoice.com to contact me with information
                  about HPE products and services relevant to my enquiry.
                </p>
              </div>
              {termsCheckError && (
                <p className="text-red text-xs text-start">
                  Please mark the above checkbox
                </p>
              )}
            </div>

            {/* Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full p-3 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 text-white text-[14px] md:leading-[22px] font-google font-medium disabled:opacity-70"
            >
              {isSubmitting ? "Submitting..." : "Start the resilience check"}
            </button>
            <div className="flex items-center gap-2 self-stretch">
              <div className="">
                <img
                  src={downloadIcon}
                  className="w-[14px] h-[14px] color-green"
                  alt=""
                />
              </div>

              <p className="text-grey-03 flex-1 text-[10px] leading-[18px] md:text-[12px] md:leading-[20px] font-inter font-medium text-start">
                <span className="text-green">Downloads immediately.</span> No
                sales call unless you want one.
              </p>
            </div>
          </form>

          {/* RIGHT - PREVIEW */}
          {showPreview && (
            <div
              className={`w-full max-w-[320px] sm:max-w-[384px] h-[310px] mx-auto `}
            >
              <ZertoDocumentPreview documents={docs} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ZertoResourcesForm;
